/** @format */

import * as React from "react";
import { Box, Text, useDisclosure, useMediaQuery } from "@chakra-ui/react";

import theme from "@src/style/theme";
import colors from "@src/style/colors";

import { useStores } from "@src/hooks/useStores";
import { observer } from "mobx-react";
import { Language } from "@src/stores/Settings";
import About_Intro_KR from "./ko/0_Intro";
import About_Business_KR from "./ko/1_Business";
import About_Value_KR from "./ko/1_Value";
import About_Founder_KR from "./ko/2_Founder";
import About_Partner_KR from "./ko/3_Partner";
import About_Intro_EN from "./en/0_Intro";
import About_Business_EN from "./en/1_Business";
import About_Value_EN from "./en/1_Value";
import About_Founder_EN from "./en/2_Founder";
import About_Partner_EN from "./en/3_Partner";

export const About: React.FC = observer(() => {
  const { settings } = useStores();

  return (
    <Box position={"static"} width="100%" bgColor={colors.white}>
      {settings.language == Language.korean ? (
        <>
          <About_Intro_KR />
          <About_Business_KR />
          <About_Value_KR />
          <About_Partner_KR />
        </>
      ) : (
        <>
          <About_Intro_EN />
          <About_Business_EN />
          <About_Value_EN />
          <About_Partner_EN />
        </>
      )}
    </Box>
  );
});

export default About;
